import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const VerificationBox = ({ onVerificationSuccess }) => {
  const { t } = useTranslation();
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [resendLoading, setResendLoading] = useState(false);

  const handleVerification = async (e) => {
    e.preventDefault();
    if (!verificationCode.trim()) {
      setError(t('verification.enterCode') || 'Bitte geben Sie den Verifizierungscode ein');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
                        const response = await fetch('/api/auth/verify-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ verificationCode: verificationCode.trim() })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(t('verification.success') || 'E-Mail erfolgreich verifiziert!');
        setVerificationCode('');
        
        // Kurz warten, dann Callback aufrufen
        setTimeout(() => {
          if (onVerificationSuccess) {
            onVerificationSuccess();
          }
        }, 1500);
      } else {
        setError(data.message || t('verification.error') || 'Verifizierung fehlgeschlagen');
      }
    } catch (err) {
      setError(t('verification.networkError') || 'Netzwerkfehler. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setResendLoading(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/auth/resend-verification', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },

      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(t('verification.codeResent') || 'Neuer Verifizierungscode wurde gesendet!');
      } else {
        setError(data.message || t('verification.resendError') || 'Code konnte nicht gesendet werden');
      }
    } catch (err) {
      setError(t('verification.networkError') || 'Netzwerkfehler. Bitte versuchen Sie es erneut.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="verification-box">
      <div className="verification-header">
        <h3>{t('verification.title') || 'E-Mail Verifizierung erforderlich'}</h3>
        <p>{t('verification.description') || 'Bitte geben Sie den Verifizierungscode ein, der an Ihre E-Mail-Adresse gesendet wurde.'}</p>
      </div>

      <form onSubmit={handleVerification} className="verification-form">
        <div className="verification-input-group">
          <label htmlFor="verificationCode">
            {t('verification.codeLabel') || 'Verifizierungscode:'}
          </label>
          <input
            type="text"
            id="verificationCode"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            placeholder={t('verification.codePlaceholder') || 'Code eingeben...'}
            className="verification-input"
            disabled={loading}
          />
        </div>

        <button 
          type="submit" 
          className="verification-button"
          disabled={loading || !verificationCode.trim()}
        >
          {loading ? (
            <span className="loading-spinner">⏳</span>
          ) : (
            t('verification.verifyButton') || 'Verifizieren'
          )}
        </button>
      </form>

      <div className="verification-actions">
        <button
          type="button"
          onClick={handleResendCode}
          className="resend-button"
          disabled={resendLoading}
        >
          {resendLoading ? (
            <span className="loading-spinner">⏳</span>
          ) : (
            t('verification.resendButton') || 'Code erneut senden'
          )}
        </button>
      </div>

      {error && (
        <div className="verification-error">
          ❌ {error}
        </div>
      )}

      {success && (
        <div className="verification-success">
          ✅ {success}
        </div>
      )}
    </div>
  );
};

export default VerificationBox;
